<template>
  <div class="trading-container main-wrapper title_container first">
    <h2
      class="text__gradient"
      :class="
        locale == 'ja' || locale == 'zh' || locale == 'vi'
          ? 'font__highlight__vi'
          : 'font__highlight'
      "
    >
      {{ $t("trading.title.01") }}
    </h2>
  </div>
  <div class="trading-container main-wrapper chart-container">
    <lazyMetaChart
      :ticker="ticker"
      :isDemoTrading="true"
      :key="ticker"
      model="meta"
    ></lazyMetaChart>
  </div>
  <!-- <div class="trading-container main-wrapper"></div> -->
  <div class="trading-container main-wrapper">
    <div class="left-pos">
      <CoinSearchView />
      <TradingView
        class="trading-view"
        :positions="singlePosition"
        :openOrderList="singleOrderList"
      />
    </div>
    <OrderBookView class="transact-view main-section" />
    <TransactView class="transact-view main-section" />
  </div>
  <div class="trading-container main-wrapper">
    <HistoryView class="history-view main-section" />
    <AccountView class="account-view main-section" />
  </div>
  <ModalAlert
    :isVisible="alertDialog.isVisible"
    :content="alertDialog.content"
    @closeDialogHandler="closeAlertDialogHandler"
    :is-btn="true"
  />
</template>

<script setup>
import ModalAlert from "@/components/common/modal/ModalAlert.vue";
import TradingView from "@/components/trading/TradingView.vue";
import CoinSearchView from "@/components/trading/CoinSearchView.vue";
import TransactView from "@/components/trading/TransactUserView.vue";
import HistoryView from "@/components/trading/HistoryView.vue";
import OrderBookView from "@/components/trading/OrderBookView.vue";
import AccountView from "@/components/trading/AccountView.vue";

import {
  computed,
  nextTick,
  onBeforeUnmount,
  onBeforeMount,
  onMounted,
  ref,
  defineAsyncComponent,
} from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import axios from "axios";
import { useI18n } from "vue-i18n";

const { t, locale } = useI18n();
const store = useStore();
const router = useRouter();
const socket = ref(null);
const activeNo = ref(1);
const alertDialog = ref({
  isVisible: false,
  content: "",
});
const lazyMetaChart = defineAsyncComponent(() =>
  import("@/components/chart/meta-chart/MetaChartCopy.vue")
);
const subscStatus = computed(() => store.state.userInfo.chartInfo.subsc_status);
const userNo = computed(() => store.state.userInfo.userInfo.user_no);
const userState = computed(() => store.state.account.userState);
const userAuth = computed(() => store.state.account.userAuth);
const isAuth = ref(false);
const ticker = computed(() => store.state.transact.ticker);

async function getUserCountryCode() {
  const response = await axios.get("https://get.geojs.io/v1/ip/country.json", {
    withCredentials: false,
  });
  const data = await response.data;
  store.commit("transact/setCountryCode", data.country);
  //   store.commit("transact/setCountryCode", "CN");
  // if (route.path === "/trading-test") {
  //   const companyIps = [
  //     process.env.VUE_APP_COMPANY_IP_1,
  //     process.env.VUE_APP_COMPANY_IP_2,
  //     process.env.VUE_APP_COMPANY_IP_3,
  //     process.env.VUE_APP_COMPANY_IP_4,
  //   ];
  //   if (!companyIps.includes(data.ip)) {
  //     location.href = isMobile.value
  //       ? "https://www.tryex.io/m/"
  //       : "https://www.tryex.io/";
  //   }
  // }
}

const closeAlertDialogHandler = () => {
  // if (!isAuth.value) {
  //   location.href = isMobile.value ? "https://www.tryex.io/m/" : "https://www.tryex.io/";
  // }
  if (alertDialog.value.content == t("alert.loginRequired")) {
    location.href = "https://www.risingx.co.kr/login";
  // } else if (subscStatus.value == 203) {
  //   location.href =
  //     "https://www.risingx.co.kr/settings/dashboard?menuName=settings&tab=selectCoin";
  } else {
    alertDialog.value.isVisible = false;
    isAuth.value = false;
  }
};
const resizeHandler = () => {
  const isMobileView = window.innerWidth <= 1024;
  store.commit("account/setIsMobile", isMobileView);
};

const connectSocket = async () => {
  if (socket.value) socket.value.close();
  const url = `wss://sigxserver.com/ws/${userNo.value}`;
  socket.value = new WebSocket(url);

  socket.value.onmessage = (e) => {
    let data;
    try {
      data = JSON.parse(e.data);
      if (data) {
        store.commit("account/setUnrealizePnl", data.total);
        store.commit("user_history/setPositionPnlList", data.data);
        if (data.trigger) {
          store.dispatch("account/fetchUserWallet");
          store.dispatch("user_history/fetchAllHistory", userNo.value);
        }
      }
    } catch (err) {
      console.error("error websocket", err);
    }
  };
};

const checkUserAuth = (type) => {
  if (userAuth.value[type]) {
    activeNo.value = 2;
  } else {
    alertDialog.value.isVisible = true;
    alertDialog.value.content = t("alert2.upgradeSmart");
    isAuth.value = true;
    return;
  }
};
onBeforeMount(async () => {
  await getUserCountryCode();
});
onMounted(async () => {
  // if (subscStatus.value == 203) {
  //   alertDialog.value.isVisible = true;
  //   alertDialog.value.content = t("trading.common.selectCoins");
  // } else {
    if (userNo.value) {
      await store.dispatch("account/fetchUserState");
      if (userState.value) {
        await store.dispatch("account/fetchUserWallet");
        await store.dispatch("user_history/fetchAllHistory", userNo.value);
        await connectSocket();
      }
    } else {
      alertDialog.value.isVisible = true;
      alertDialog.value.content = t("alert.loginRequired");
    }
    await nextTick();
    window.addEventListener("resize", resizeHandler);
    const isMobileView = window.innerWidth <= 1024;
    store.commit("account/setIsMobile", isMobileView);
  // }
});
onBeforeUnmount(() => {
  window.removeEventListener("resize", resizeHandler);
  if (socket.value) socket.value.close();
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/trading/common.scss";
@import "@/assets/scss/components/trading/index.scss";
</style>
